import { isMobile } from '@vindr/utils/mobile';
import { Col, Typography } from 'antd';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface KeyImageDisplayProps {
  keyImages: Array<{ imageSrc: string }>;
  openRecordVideo: boolean;
  hasPermission: boolean;
}

const KeyImageDisplay: React.FC<KeyImageDisplayProps> = ({
  keyImages,
  openRecordVideo,
  hasPermission,
}) => {
  const { t } = useTranslation('Vindoc');

  if (!hasPermission || !keyImages.length || openRecordVideo) {
    return null;
  }

  return (
    <Col sm={24} xxl={keyImages.length ? (isMobile() ? 3 : 5) : 0}>
      <Title className="mb-0 mt-2 pb-3 pt-0 min-[1300px]:mt-0" level={4}>
        {t('Key Image')}
      </Title>
      <div
        className="flex w-full flex-wrap overflow-scroll min-[1300px]:flex-col min-[1300px]:flex-nowrap"
        style={{ maxHeight: 'calc(100vh - 150px)' }}
      >
        {keyImages.map(
          (it, idx) =>
            it?.imageSrc && (
              <img
                key={idx}
                alt={`Key Image ${idx + 1}`}
                className="mb-1 mr-1 max-[1300px]:max-h-24"
                src={it.imageSrc}
              />
            )
        )}
      </div>
    </Col>
  );
};

export default memo(KeyImageDisplay);
